import { PinInput } from './PinInput'

interface ConfirmPinStepProps {
  pin: string[]
  setPin: React.Dispatch<React.SetStateAction<string[]>>
}

export function ConfirmPinStep({ pin, setPin }: ConfirmPinStepProps) {
  return (
    <div className="space-y-2 pt-4">
      <PinInput pin={pin} setPin={setPin} />
    </div>
  )
}
